import React, { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { CalendarWithTime } from "../common/CalendarWithTime";
import { BookingForm } from "../common/BookingForm";

export const BookingSection = () => {
    const [date, setDate] = useState(null)
    const [time, setTime] = useState(null)
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [comment, setComment] = useState("")
    const [blockedTimes, setBlockedTimes] = useState([])

    const formatLocalDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
    }
    const dateKey = useMemo(() => (date ? formatLocalDate(date) : null), [date])

    useEffect(() => {
        setBlockedTimes([])
    }, [date])

    const onSubmit = async (e) => {
        e.preventDefault()

        // rawPhone уже содержит чистые цифры из состояния
        const rawPhone = phone;

        if (!date || !time || !name || !rawPhone) {
            toast.error("Заполните все обязательные поля")
            return
        }

        // Валидация номера телефона (например, 375 и 9 цифр после)
        const phoneRegex = /^375\d{9}$/;
        if (!phoneRegex.test(rawPhone)) {
            toast.error("Пожалуйста, введите корректный номер телефона (например, +375 (XX) XXX-XX-XX)");
            return;
        }

        try {
            const payload = { date: dateKey, time, name, phone: '+' + rawPhone, comment }
            const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/api/booking", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })

            const data = await res.json()
            if (!res.ok) throw new Error(data.message || "Ошибка бронирования")

            toast.success("Запись успешно создана. Мы свяжемся с вами по телефону.")
            setBlockedTimes(prev => [...prev, time])
            setTime(null)
            setName("")
            setPhone("")
            setComment("")
        } catch (err) {
            toast.error(err.message)
        }
    }

    return (
        <section id="booking" className="py-16 relative overflow-hidden">
            <div
                className="absolute overflow-hidden z-0 right-[-25%] top-[10%] sm:top-0 w-[100vw] md:w-[100vw] h-[55vh] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/vetka-4.svg')", transform: "rotateZ(180deg)" }}
            />
            <div className="mx-auto relative z-5 max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-2 gap-8 items-stretch">
                    <div>
                        <h2 className="font-serif text-3xl text-olive-950">Запись на встречу</h2>
                        <p className="mt-2 text-olive-900/70 text-sm">Выберите удобные дату и время.</p>
                        <CalendarWithTime
                            dateKey={dateKey}
                            dateValue={date}
                            onDateChange={setDate}
                            timeValue={time}
                            onTimeChange={setTime}
                            blockedTimes={blockedTimes}
                        />

                    </div>
                    <BookingForm
                        onSubmit={onSubmit}
                        date={dateKey}
                        time={time}
                        name={name}
                        phone={phone}
                        comment={comment}
                        setName={setName}
                        setPhone={setPhone}
                        setComment={setComment}
                    />
                </div>
            </div>
        </section>
    )
}
